<template>
  <div>
    <Alerts ref="alert"/>
    <Forms ref="frmSinister"
            :title="this.$lang.Sinister.Details.TitleForm"
            :showHelp="false"
            :showClearButton="hasRole(this.roles.RW_REG_TABDETAILS) && !isCompleted"
            :showSaveButton="hasRole(this.roles.RW_REG_TABDETAILS) && !isCompleted"
            v-on:Clear="onClear"
            v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-3">
          <label for="txtCodeSinister"><small v-show="form.sinisterCode.required" class="text-danger">*</small>  {{$lang.Sinister.Details.SinisterCode}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtCodeSinister"
                          :placeholder="$lang.Sinister.Details.PlaceholderEnterCodeSinister"
                          v-model="form.sinisterCode.value"
                          :size="form.sinisterCode.maxlength"
                          :required="form.sinisterCode.required"
                          :state="form.sinisterCode.state"
                          :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-1">
          <label for="txtSinisterVersion"><small v-show="form.sinisterVersion.required" class="text-danger">*</small> {{$lang.Sinister.Details.Version}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtSinisterVersion"
                          :placeholder="'00'"
                          v-model="form.sinisterVersion.value"
                          :maxlength="form.sinisterVersion.maxlength"
                          :required="form.sinisterVersion.required"
                          :state="form.sinisterVersion.state"
                          :disabled="isCompleted"
                          @blur.native="onCheckSinister"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxSinisterInsurer"><small v-show="form.insuranceID.required" class="text-danger">*</small> {{$lang.Sinister.Details.Insurer}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.insuranceID.value"
                          :options="getAllInsurer"
                          :state="form.insuranceID.state"
                          class="mb-3"
                          name="cbxSinisterInsurer"
                          :disabled="isCompleted"
                          @change="onChangeInsurance">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxSinisterStage"><small v-show="form.stageID.required"  class="text-danger">*</small> {{$lang.Sinister.Details.Stage}}: <a v-if="isCompleted && hasRole(this.roles.FUN_UNLOCKREG)" href="javascript:void(0)" v-b-tooltip.hover :title="'Clique para desbloquear o estágio'" @click="onUnlockStage"><i class="fa fa-unlock-alt" aria-hidden="true"></i></a></label>
          <div class="input-group">
            <b-form-select v-model="form.stageID.value"
                          :options="getAllStage"
                          :state="form.stageID.state"
                          class="mb-3"
                          name="cbxSinisterStage"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxSinisterTypeInspection"><small v-show="form.regulationTypeID.required" class="text-danger">*</small> {{$lang.Sinister.Details.TypeRegulation}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.regulationTypeID.value"
                          :options="getAllRegulationType"
                          :state="form.regulationTypeID.state"
                          class="mb-3"
                          name="cbxSinisterTypeInspection"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtSinisterDate"><small v-show="form.sinisterDate.required"  class="text-danger">*</small> {{$lang.Sinister.Details.DateOccurrence}}:</label>
          <div class="input-group">
            <datepicker name="txtSinisterDate" v-model="form.sinisterDate.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtReceiptDate"><small v-show="form.receiptDate.required"  class="text-danger">*</small> {{$lang.Sinister.Details.ReceiptDate}}:</label>
          <div class="input-group">
            <datepicker name="txtReceiptDate" v-model="form.receiptDate.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxSinisterResponsible"><small v-show="form.responsibleID.required" class="text-danger">*</small> {{$lang.Sinister.Details.Responsible}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.responsibleID.value"
                          :options="getAllAnalyst"
                          :state="form.responsibleID.state"
                          class="mb-3"
                          name="cbxSinisterResponsible"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="cbxBusinessType"><small v-show="form.businessTypeID.required" class="text-danger">*</small> {{$lang.Sinister.Details.BusinessType}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.businessTypeID.value"
                          :options="form.businessTypeID.options"
                          :state="form.businessTypeID.state"
                          class="mb-3"
                          name="cbxBusinessType"
                          :disabled="isCompleted"
                          @change="onChangeBusinessType">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxProduct"><small v-show="form.productID.required" class="text-danger">*</small> {{$lang.Sinister.Details.Product}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.productID.value"
                          :options="form.productID.options"
                          :state="form.productID.state"
                          class="mb-3"
                          name="cbxProduct"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxBudgetSystem"><small v-show="form.budgetSystemID.required" class="text-danger">*</small> {{$lang.Sinister.Details.BudgetSystem}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.budgetSystemID.value"
                          :options="getAllBudgetSystem"
                          :state="form.budgetSystemID.state"
                          class="mb-3"
                          name="cbxBudgetSystem"
                          :disabled="isCompleted">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtBudgetNumber"><small v-show="form.budgetNumber.required"  class="text-danger">*</small> {{$lang.Sinister.Details.BudgetNumber}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtBudgetNumber"
                          :placeholder="'012345689'"
                          v-model="form.budgetNumber.value"
                          :size="form.budgetNumber.maxlength"
                          :required="form.budgetNumber.required"
                          :state="form.budgetNumber.state"
                          :disabled="isCompleted"/>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12 intermediate-bar"><i class="fa fa-wrench"></i>&nbsp; {{$lang.Sinister.Details.DataMachineWorkshop}}</div>
      </div>
      <SinisterMechanicalWorkshop ref="MechanicalWorkshop" @Edit="onEditMechanicalWorkshop" />

      <div class="form-group row"><div class="col-md-12 intermediate-bar"><i class="fa fa-car"></i>&nbsp; {{$lang.Sinister.Details.DataCar}}</div></div>
      <div class="form-group row">
        <div class="col-md-4">
           <label for="cbxAutoType"><small v-show="form.autoTypeID.required" class="text-danger">*</small> {{$lang.AutoModel.Autotype}}:</label>
            <div class="input-group">
              <b-form-select v-model="form.autoTypeID.value"
                            :options="form.autoTypeID.options"
                            :state="form.autoTypeID.state"
                            class="mb-3"
                            name="cbxAutoType"
                            :disabled="isCompleted"
                            @change="onChangeAutoType">
                  <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                </template>
              </b-form-select>
            </div>
        </div>
        <div class="col-md-4">
          <label for="cbxBrand"><small v-show="form.brandID.required" class="text-danger">*</small> {{$lang.AutoModel.LabelBrand}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.brandID.value"
                              :options="form.brandID.options"
                              :state="form.brandID.state"
                              class="mb-3"
                              name="cbxBrand"
                              :disabled="isCompleted"
                              @change="onChangeBrand">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <optgroup :label="$lang.Common.PlaceholderOptGroupDefault">
                  <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                  <option :value="null">{{$lang.Common.PlaceholderAddSelect}}</option>
                </optgroup>
                <optgroup :label="$lang.Common.PlaceholderOptGroupOptions"></optgroup>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxAutoModel"><small v-show="form.autoModelID.required" class="text-danger">*</small> {{$lang.Sinister.Details.AutoModel}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.autoModelID.value"
                                  :options="form.autoModelID.options"
                                  :state="form.autoModelID.state"
                                  class="mb-3"
                                  name="cbxBrand"
                                  :disabled="isCompleted">
                    <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <optgroup :label="$lang.Common.PlaceholderOptGroupDefault">
                      <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
                      <option :value="null">{{$lang.Common.PlaceholderAddSelect}}</option>
                    </optgroup>
                    <optgroup :label="$lang.Common.PlaceholderOptGroupOptions"></optgroup>
                  </template>
                </b-form-select>
              </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtYear"><small v-show="form.year.required"  class="text-danger">*</small> {{$lang.Sinister.Details.Year}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtYear"
                          :placeholder="'2018-2018'"
                          v-model="form.year.value"
                          :size="form.year.maxlength"
                          :required="form.year.required"
                          :state="form.year.state"
                          v-mask="['####-####']"
                          :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtColor"><small v-show="form.color.required" class="text-danger">*</small> {{$lang.Sinister.Details.Color}}:</label>
              <div class="input-group">
                 <b-form-input type="text"
                          name="txtColor"
                          :placeholder="'Branco'"
                          v-model="form.color.value"
                          :size="form.color.maxlength"
                          :required="form.color.required"
                          :state="form.color.state"
                          :disabled="isCompleted"/>
              </div>
        </div>
        <div class="col-md-4">
          <label for="txtPlate"><small v-show="form.plate.required"  class="text-danger">*</small> {{$lang.Sinister.Details.Board}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtPlate"
                          :placeholder="'BRA-12J4'"
                          v-model="form.plate.value"
                          :size="form.plate.maxlength"
                          :required="form.plate.required"
                          :state="form.plate.state"
                          :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-4">
         <label for="txtChassis"><small v-show="form.chassis.required"  class="text-danger">*</small> {{$lang.Sinister.Details.Chassis}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtChassis"
                          :placeholder="'XXXXXXXXXXXXXXXXX'"
                          v-mask="'XXXXXXXXXXXXXXXXX'"
                          v-model="form.chassis.value"
                          :size="form.chassis.maxlength"
                          :required="form.chassis.required"
                          :state="form.chassis.state"
                          :disabled="isCompleted"/>
          </div>
        </div>
      </div>

      <div class="form-group row"><div class="col-md-12 intermediate-bar"><i class="fa fa-users"></i>&nbsp; DADOS SEGURADO E TERCEIROS</div></div>
      <b-tabs>
        <b-tab active :title="$lang.Sinister.Details.Insured" class="tab-internal">
          <template slot="title">
            <i class="fa fa-user text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.Details.Insured }}</span>
          </template>
          <Person ref="PersonInsured" v-on:Edit="onEditInsured"/>
        </b-tab>
        <b-tab :title="$lang.Sinister.Details.Conductor" class="tab-internal">
          <template slot="title">
            <i class="fa fa-user text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.Details.Conductor }}</span>
          </template>
          <Person ref="PersonConductor" v-on:Edit="onEditConductor" />
        </b-tab>
        <b-tab :title="$lang.Sinister.Details.Third" class="tab-internal">
          <template slot="title">
            <i class="fa fa-user text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.Details.Third }}</span>
          </template>
          <Person ref="PersonThird" v-on:Edit="onEditThird" />
        </b-tab>
      </b-tabs>

      <div class="form-group row"><div class="col-md-12 intermediate-bar"><i class="fa fa-bullhorn"></i>&nbsp; DADOS PARECER E RECLAMADO</div></div>
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtSeem"><small v-show="form.seem.required" class="text-danger">*</small> {{$lang.Sinister.Details.Seem}}:</label>
          <b-form-textarea name="txtSeem"
                          v-model="form.seem.value"
                          :placeholder="$lang.Sinister.Details.PlaceholderSeem"
                          :rows="form.seem.rows"
                          :size="form.seem.maxlength"
                          :noResize="form.seem.noResize"
                          :disabled="isCompleted"/>
        </div>
        <div class="col-md-6">
          <label for="txtDamageClaimed"><small v-show="form.damageClaimed.required" class="text-danger">*</small> {{$lang.Sinister.Details.DamageClaimed}}:</label>
          <b-form-textarea name="txtDamageClaimed"
                          v-model="form.damageClaimed.value"
                          :placeholder="$lang.Sinister.Details.PlaceholderDamageClaimed"
                          :rows="form.damageClaimed.rows"
                          :size="form.damageClaimed.maxlength"
                          :noResize="form.damageClaimed.noResize"
                          :disabled="isCompleted"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtObservations"><small v-show="form.description.required" class="text-danger">*</small> {{$lang.Sinister.Details.GeneralObservations}}:</label>
          <b-form-textarea name="txtObservations"
                          v-model="form.description.value"
                          :placeholder="$lang.Sinister.Details.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"
                          :disabled="isCompleted"/>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>

    <b-modal ref="modal-pending-regulation" hide-footer title="PENDÊNCIA ENCONTRADA">
      <div class="d-block text-center">
        <h3>Há uma versão não concluída!</h3>
        <p class="mt-3 mb-3" style="background-color: #efefef;padding-top: 7px;padding-bottom: 7px;border-radius: 5px;">
          <span v-html="DetailsPendingRegulation"></span>
        </p>
        <h5 class="pt-2">
          <!--Desejar continuar o cadastro?-->
          Você precisa concluir a versão para continuar!
        </h5>
      </div>
      <div class="text-center pb-2">
        <b-button class="mt-2 btn-third" @click="onCloseModalClear">&nbsp;<i class="fa fa-times-circle" aria-hidden="true"></i> <strong>Fechar &nbsp;</strong></b-button>&nbsp;
        <!--
        <b-button class="mt-2" variant="danger" @click="onCloseModalClear">&nbsp;<i class="fa fa-times-circle" aria-hidden="true"></i> <strong>Não &nbsp;</strong></b-button>&nbsp;
        <b-button class="mt-2" variant="success" @click="onCloseModal">&nbsp;<i class="fa fa-check-circle" aria-hidden="true"></i> <strong>Sim &nbsp;</strong></b-button>
        -->
      </div>
    </b-modal>
    <b-modal ref="modal-unlock-regulation" size="lg" hide-footer title="DESBLOQUEIO DE ESTÁGIO DA REGULAÇÃO">
      <div class="d-block text-center">
        <h3 class="pt-2">
          <i class="fa fa-unlock-alt" aria-hidden="true"></i> Deseja realmente desbloquear a regulação?
        </h3>
        <div>
          <small>Você irá debloquear uma regulação concluída e ela irá retornar ao estágio anterior (EM DIGITAÇÃO)</small>
        </div>
      </div>
      <div class="text-center pt-3 pb-4">
        <b-button class="mt-2" variant="danger" @click="onUnlockStageModalClose">&nbsp;<i class="fa fa-times-circle" aria-hidden="true"></i> <strong>Não &nbsp;</strong></b-button>&nbsp;
        <b-button class="mt-2" variant="success" @click="onUnlockStageModalYes">&nbsp;<i class="fa fa-check-circle" aria-hidden="true"></i> <strong>Sim &nbsp;</strong></b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import sinisterdetails from './sinisterdetails.js'

export default sinisterdetails
</script>
<style lang="scss" scoped>
.tab-internal {
  border-left: solid 1px #cfd8dc;
  border-right: solid 1px #cfd8dc;
  border-bottom: solid 1px #cfd8dc;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/details/sinisterdetails.vue